import React, { Component } from "react";
import "./ScoreCard.css";
import { Messages } from 'primereact/messages';
import { Col, Row, Button, Form, Modal, Card } from "react-bootstrap";
import utils from "./../../utils";
import RoleConstant from "./../../constants/RoleConstant";
import EndpointConstant from "./../../constants/EndpointConstant";
import MessageConstant from "./../../constants/MessageConstant";
// import RouterConstant from './../../constants/RouterConstant';
import CommonService from "../../commonService/CommonService";
import PopupModels from "./../PopupModels/PopupModels";
import PropTypes from "prop-types";
import ViewScoreCardDetails from "./ViewScoreCardDetails";
// import moment from 'moment';
import CommentHistory from "./../ErrorList/CommentHistory";
import { MultiSelect } from 'react-multi-select-component';
import Moment from 'react-moment';
import moment from 'moment';

class EditScoreCard extends Component {
  _isMounted = false
  constructor(props) {
    super(props);
    const commentHistory = Array.isArray(props.details.comments)
    ? props.details.comments
    : [];

    const latestComment = [...commentHistory].sort(
    (a, b) => (b.modifiedAt || 0) - (a.modifiedAt || 0)
    )[0];

    const currentUserName =
      utils.getSessionItem("firstName") +
      " " +
      utils.getSessionItem("lastName");

    const savedComment =
      latestComment?.status === "Saved" &&
      latestComment?.modifiedBy === currentUserName
        ? latestComment.comments || ""
        : "";
    this.state = {
      ...this.props.details,
      questionaries:
        this.props.scoreCard === "new"
          ? []
          : this.props.questionaries.questionaries,
      questionset:
        this.props.scoreCard === "new"
          ? []
          : this.props.details.questionset,
      questionsets: this.props.questionaries,
      selectedQuestionset:
        this.props.scoreCard === "new"
          ? ""
          : this.props.questionaries.questionsetid,
      scorecardUpdateModel: false,
      valid: false,
      error: false,
      countTrue: 0,
      countFalse: 0,
      percent: 0,
      finalScore: this.props.details.finalScore
        ? this.props.details.finalScore
        : 0,
      updatedScore: this.props.details.updatedScore ? this.props.details.updatedScore : [],
      scorecardId: this.props.scoreCard === "new" ? "" : this.props.details.id,
      showViewDetails: false,
      scorecardDetails: this.props.scoreCard === "new" ? []: [this.props.details],
      AEID_Q2_AE_Missed_QualityMonitorQC_Error: "",
      PC_Q1_IPRC_Match_QualityMonitorQC_Error: "",
      PCID_Q2_Missed_QualityMonitorQC_Error: "",
      AE_Q3_IPRC_QualityMonitorQC_Error: "",
      AE_Q2_HCP_QualityMonitorQC_Error: "",
      AE_Cap_IRPC_Match_QualityMonitorQC_Error: "",
      scorecardErrorModel: false,
      newcomment: savedComment,
      comment: commentHistory,
      showComment: false,
      question: [],
      isComplete: false,
      scorecardNoUserError: false,
      questionsetName: this.props.details.questionsetName
        ? this.props.details.questionsetName
        : "",
      questionsetid: this.props.details.questionsetid
        ? this.props.details.questionsetid
        : "",
      adminUsers: [],
      showAdminPopup: false,
      selectedAdmin: "",
      previousAssignedToAdminName:
        this.props.scoreCard === "edit"
          ? this.props.details.assignedToAdminName
          : "",
      previousAssignedToAdmin:
        this.props.scoreCard === "edit"
          ? this.props.details.assignedToAdmin
          : "",
      previousAssignedToName:
        this.props.scoreCard === "edit"
          ? this.props.details.assignedToName
          : "",
      previousAssignedTo:
        this.props.scoreCard === "edit" ? this.props.details.assignedTo : "",
      scorecardName:
        this.props.scoreCard === "edit" ? this.props.details.ScorecardName : "",
      scorecards: [],
      duplicateScorecard: false,
      intervalId: null,
      showAlertModal: false,
      modalMessage: "",
      isDraft: false,
      extractValidation: false,
      extractErrMsg: "",
      messageHideTimer: null,
      autoSaveTimer: null,     
      lastSaveAt: 0,            
      lastSavedSnapshot: null,  
      MIN_INTERVAL_MS: 1800,

      lastSaveWasAuto: false,   
      isFormDisabled: false,

      formChanged: false,
      isAutoSave: false, 
      _ensureIdPromise:  null, 
      isUpdateSaveInFlight: false,
      savingMessageShown: false,
      lastSavePromise: null,   
      saveInFlight: false,
      blockingNav: false,

      isPassed: this.props.details.isPassed
        ? this.props.details.isPassed
        : null,
    };    
    this.messages = React.createRef();
    this.updateScorecard = this.updateScorecard.bind(this);
    this.completeScorecard = this.completeScorecard.bind(this);
    this.handleChangeYesNo = this.handleChangeYesNo.bind(this);
    this.handleCommentsChange = this.handleCommentsChange.bind(this);
    this.handleUpdateClose = this.handleUpdateClose.bind(this);
    this.handleScorecardValidation = this.handleScorecardValidation.bind(this);
    this.handleValidation = this.handleValidation.bind(this);
    this.goBackTo = this.goBackTo.bind(this);
    this.handleExtractValidationClose =
      this.handleExtractValidationClose.bind(this);

    this.showHistory = this.showHistory.bind(this);
    this.hideHistory = this.hideHistory.bind(this);
    this.goBackToHome = this.goBackToHome.bind(this);
    this.routetoQM = this.routetoQM.bind(this);
    this.questionsetNameChanges = this.questionsetNameChanges.bind(this);
    this.getQuestionariesList = this.getQuestionariesList.bind(this);
    this.showAdminDetails = this.showAdminDetails.bind(this);
    this.handleAdminPopupClose = this.handleAdminPopupClose.bind(this);
    this.submitScorecard = this.submitScorecard.bind(this);
  }

  getQuestionariesList() {
    let data = {};
    let self = this;
    utils.makeRequest(
      this,
      EndpointConstant.SCORECARD_QUESTIONARIE_LIST,
      data,
      function (result) {
        utils.hideLoader();
        if (result.error === false) {
          self.loading = false;
          self.setState({
            questionsets: result.Questionaries,
          });
        }
      }
    );
  }

  componentDidMount() {
    this._isMounted = true;
    this.getQuestionariesList();
    this.getScoreCardList();

    if (!this.state.ScorecardName && this.props.details?.ScorecardName) {
      this.setState({ ScorecardName: this.props.details.ScorecardName });
    }
    // window.addEventListener("beforeunload", this.onBeforeUnload);

    const fiveMinutesInSeconds = 5 * 60;

    const checkSessionValidity = () => {
      const sessionValidity = JSON.parse(
        utils.getSessionItem("sessionValidity")
      );
      const currentTime = Math.round(new Date().getTime() / 1000);

      const remainingTime = sessionValidity - currentTime;
      if (remainingTime <= 0) {
        clearInterval(this.state.intervalId);
        return;
      }
      if (remainingTime <= fiveMinutesInSeconds) {
        let data = {}
        utils.makeRequestInBackground(this, EndpointConstant.EXTEND_SESSION_VALIDITY, data, function(result){
          if(result && result.validity){
            utils.setSessionItem("sessionValidity", result.validity);
          }
        })
    };
  }
    // Check every minute (60000 milliseconds)
    const intervalId = setInterval(checkSessionValidity, 60000);
    this.setState({ intervalId });
  }

  componentWillUnmount() {
    this._isMounted = false;    
    // window.removeEventListener("beforeunload", this.onBeforeUnload);
    clearInterval(this.state.intervalId);     
    
    if (this.autoSaveTimer) clearTimeout(this.autoSaveTimer);

    if (this.messageHideTimer) {
      clearTimeout(this.messageHideTimer);
      this.messageHideTimer = null;
    }
  }

  // onBeforeUnload = (e) => {
  //   console.log("event", e)
  //   if (!this.hasUnsavedChanges()) return;
    
    

  //   try {
  //     this.showMessage("Couldn't save your changes please try again..", 'info')
  //     if (this.autoSaveTimer) {
  //       clearTimeout(this.autoSaveTimer);
  //       this.autoSaveTimer = null;
  //     }            

  //    } catch (err) {
  //     // Silent failure — browser may already be unloading
  //   }

  //   e.preventDefault();
  //   e.returnValue = "";
  // };

  
// hasUnsavedChanges() {
//   return this.state.formChanged;
// }
  
 handleInputChange = (field, value) => {
    this.setState({ [field]: value, formChanged: true, isAutoSave: true });
    this.triggerAutoSave();
  };

  
  hasAutoSaveStarted = false;
  triggerAutoSave = () => {
    if (this.saveInFlight) return;

    if (this.autoSaveTimer) {
      return;
    }

    const now = Date.now();
    const elapsed = now - this.lastSaveAt;

    const minIntervalDelay =
      elapsed < this.MIN_INTERVAL_MS
        ? this.MIN_INTERVAL_MS - elapsed
        : 0;

    const baseDelay =  this.props.scoreCard === "new" 
      ? this.hasAutoSaveStarted ? (this.state.autoSaveDelay || 10000) : 0 : (this.state.autoSaveDelay || 10000);
      

    const delay = baseDelay + minIntervalDelay;

    this.autoSaveTimer = setTimeout(() => {
      this.autoSaveTimer = null;
      if (this.state.formChanged && !this.saveInFlight) {
        this.saveScorecard(true).finally(() => {
          this.hasAutoSaveStarted = true;
        });
      }
    }, delay);
  };

requestAsPromise = (isAutoSave, endpoint, payload, headerData) => {
  return new Promise((resolve, reject) => {
    const method = isAutoSave ? utils.makeRequestInBackground : utils.makeRequest;
    try {
      method(this, endpoint, payload, (result) => {
        if (result && (result.error === false || result.error === "false")) {
          resolve(result);
        } else if (result && typeof result === 'object' && !('error' in result)) {
          resolve(result); 
        } else {
          const msg = (result && (result.message || result.errorMessage)) || "Request failed";
          reject(new Error(msg));
        }
      }, headerData);
    } catch (e) {
      reject(e);
    }
  });
};


  removePassedValue() {
    this.setState({ isPassed: null });
  }

  showAlertModal = (message) => {
    this.setState({
      showAlertModal: true,
      modalMessage: message,
    });
  };

  hideAlertModal = () => {
    this.setState({ showAlertModal: false });
  };

  savingCounters = {};
  SAVING_KEY = 'SAVING_SCORECARD';


  clearMessageTimer = () => {
    if (this.messageHideTimer) {
      clearTimeout(this.messageHideTimer);
      this.messageHideTimer = null;
    }
  };

 
  showMessage = (message, severity = 'success', life = 3000) => {
    const inst = this.messages?.current;
    if (!inst) return;

    this.clearMessageTimer();

    inst.show([
      {
        severity,   
        summary: '',
        detail: message,
        sticky: true,
        closable: false
      }
    ]);

    this.messageHideTimer = setTimeout(() => {
      this.messages?.current?.clear();
      this.messageHideTimer = null;
    }, life);
  };


  showSavingMessage = (message = 'Scorecard saving is in progress…', key = this.SAVING_KEY) => {
    const inst = this.messages?.current;
    if (!inst) return;

    this.savingCounters[key] = (this.savingCounters[key] || 0) + 1;

    if (this.savingCounters[key] === 1) {     
      this.clearMessageTimer();
      
      inst.clear();

      inst.show([
        {
          severity: 'info',
          summary: '',
          detail: message,
          sticky: true,
          closable: false
        }
      ]);
    }
  };
  
  hideSavingMessage = (key = this.SAVING_KEY) => {
    const inst = this.messages?.current;
    if (!inst) return;

    if (!this.savingCounters[key]) return;

    this.savingCounters[key] -= 1;

    if (this.savingCounters[key] === 0) {
      delete this.savingCounters[key];
      inst.clear(); 
    }
  };

  flushAutoSaveAndWait = () => {
  if (this.autoSaveTimer) {
    clearTimeout(this.autoSaveTimer);
    this.autoSaveTimer = null;

    return this.saveScorecard(true);
  }

  if (this.saveInFlight || this.isUpdateSaveInFlight) {
    return this.lastSavePromise || Promise.resolve();
  }

  return Promise.resolve();
};

  goBackTo = async () => {
  try {
    if (this.isUpdateSaveInFlight || this.saveInFlight || this.autoSaveTimer ) {
      this.setState({ blockingNav: true});
      utils.showLoader();
      if (!this.savingMessageShown) {
        this.showSavingMessage('Scorecard saving is in progress...', this.SAVING_KEY);
        this.savingMessageShown = true;
      }
      await this.flushAutoSaveAndWait();
      utils.hideLoader()
      if (this.savingMessageShown) {
        this.hideSavingMessage(this.SAVING_KEY);
        this.savingMessageShown = false;
      }
    }


    if (this.props.scoreCard === "new") {
      if (!this.state.scorecardId) {
        this.props.hideDetails();
      } else {
        await this.handleUpdateClose(false);
        this.props.hideEditScoreCard();
      }
      return; 
    }

    if (this.props.scoreCard === "edit") {
      if (this.state.isAutoSave) {
        await this.handleUpdateClose(false);
        this.setState({ showViewDetails: true });
        this.props.hideEditScoreCard();
      }
      this.props.hideDetails?.();
    } else {
      await this.handleUpdateClose(false);
      this.setState({ showViewDetails: true });
    }

  } catch (err) {
    if (this.savingMessageShown) {
      this.hideSavingMessage(this.SAVING_KEY);
      this.savingMessageShown = false;
    }
    this.showMessage("Save failed or took too long. Please try again.", "error");
  } finally {
    this.setState({ blockingNav: false, formDisabled: false });
  }
};


isValidForm() {
    let data = {
      ...this.state,
    };
    if (
      utils.getSessionItem("role") === RoleConstant.QualityMonitor &&
      data.AE_Cap_IRPC_Match !== "" &&
      data.AE_Cap_IRPC_Match_QualityMonitorQC &&
      data.AEID_Q2_AE_Missed &&
      data.AEID_Q2_AE_Missed_QualityMonitorQC &&
      data.AE_Q2_HCP &&
      data.AE_Q2_HCP_QualityMonitorQC &&
      data.AE_Q3_IPRC &&
      data.AE_Q3_IPRC_QualityMonitorQC &&
      data.PCID_Q2_Missed &&
      data.PCID_Q2_Missed_QualityMonitorQC
    ) {
      this.setState({ valid: true });
    }
    // console.log("123"+data);
  }
  routetoQM = async (value) => {
    try {
      if (this.isUpdateSaveInFlight || this.saveInFlight || this.autoSaveTimer) {
        this.setState({ blockingNav: true });
        utils.showLoader();
        if (!this.savingMessageShown) {
          this.showSavingMessage('Scorecard saving is in progress...', this.SAVING_KEY);
          this.savingMessageShown = true;
        }
        await this.flushAutoSaveAndWait();
        utils.hideLoader()
        if (this.savingMessageShown) {
          this.hideSavingMessage(this.SAVING_KEY);
          this.savingMessageShown = false;
        }
      }
     const isAutoSave = value === true; // explicit mode
    
    if (value === false) {
      // Wait for state update before proceeding
      await new Promise((resolve) => {
        this.setState({ isAutoSave: false }, resolve);
      });
    }
    let self = this;
    let data = this.handleRequestParam();
    data.type =
      this.state.stage === "otherAdmin"
        ? "OTHER_ADMIN_ASSIGN_TO_ADMIN"
        : "ADMIN_ASSIGN_TO_USER";
    data.createdBy = this.state.createdBy;
    data.questionsetid = this.state.questionsetid;
    data.questionsetName = this.state.questionsetName;
    data.assignedToAdmin = this.state.createdBy;
    data.assignedToAdminName = this.state.QMAssociate;
    data.assignedToRole = this.props.details.createdByRole;
    data.createdByRole = this.props.details.createdByRole;
    data.createdByScoreCard = this.props.details.createdBy;
    data.previousAssignedToAdminName = this.state.previousAssignedToAdminName;
    data.previousAssignedToAdmin = this.state.previousAssignedToAdmin;
    data.previousAssignedToName = this.state.previousAssignedToName;
    data.previousAssignedTo = this.state.previousAssignedTo;
    data.finalScore = this.state.finalScore;
    data.updatedScore = this.state.updatedScore;
    data.questionset = this.state.questionset;
    data.ScorecardName =
      this.state.ScorecardName === undefined
        ? ""
        : this.state.ScorecardName.trim();
    data.isAssignedToReviewer = false;
    // data.comments = this.state.newcomment
    //   ? this.state.newcomment
    //   : this.state.comment[this.state.comment.length - 1]?.status === "Saved"
    //     ? this.state.comment[this.state.comment.length - 1]?.comments
    //     : this.state.newcomment;
    data.comments = this.state.newcomment;

    // console.log('data', data, this.state);
    utils.makeRequest(
      this,
      EndpointConstant.UPDATE_SCORECARD,
      data,
      function (result) {
        if (result.error === false || result.error === "false") {
          self.setState({
            scorecardUpdateModel: true,
            scorecardId: result.scorecardId,
            isDraft: false,
            isComplete: false
          });
        } else if (result.error && result.errorCode === "S_USER_NOT_EXIST") {
          self.setState({ scorecardNoUserError: true });
        }
      }
    );

    // let self = this;
    // let data = {
    //   ...this.state
    // }
    // delete data.className;
    // delete data.createdAt;
    // delete data.modifiedAt;
    // delete data.valid;
    // if((this.props.scoreCard === 'editquality' || this.props.scoreCard==='edit') && (utils.getSessionItem("userId")!==this.props.details.createdBy && this.props.details.stage==='2') && this.state.qualityMonitorQCBy){
    //   data.type = 'QUALITYMONITOR_ASSIGN_TO_QUALITYMONITOR'
    //   data.assignedTo = RoleConstant.QualityMonitor
    //   data.comments=this.state.newcomment
    //   data.stage='1';
    //   utils.makeRequest(this, EndpointConstant.UPDATE_SCORECARD, data, function (result) {
    //     if (result.error === false || result.error === "false") {
    //       self.setState({
    //         scorecardUpdateModel: true,
    //         scorecardId: result.scorecardId
    //       });
    //     }

    //   })
    // }
    // else{
    //   this.setState({ scorecardErrorModel: true })
    // }
  } catch (err) {
      if (this.savingMessageShown) {
        this.hideSavingMessage(this.SAVING_KEY);
        this.savingMessageShown = false;
      }
      this.showMessage("Save failed or took too long. Please try again.", "error");
    } finally {
      this.setState({ blockingNav: false, formDisabled: false });
    }
  }

  updateScorecard = async (value) => {
    try {
      if (this.isUpdateSaveInFlight || this.saveInFlight || this.autoSaveTimer) {
        this.setState({ blockingNav: true });
        utils.showLoader();
        if (!this.savingMessageShown) {
          this.showSavingMessage('Scorecard saving is in progress...', this.SAVING_KEY);
          this.savingMessageShown = true;
        }
        await this.flushAutoSaveAndWait();
        utils.hideLoader()
        if (this.savingMessageShown) {
          this.hideSavingMessage(this.SAVING_KEY);
          this.savingMessageShown = false;
        }
      }
      const isAutoSave = value === true; // explicit mode

      if (value === false) {
        // Wait for state update before proceeding
        await new Promise((resolve) => {
          this.setState({ isAutoSave: false }, resolve);
        });
      }
      const isError = this.handleScorecardValidation();
      const isValid = this.handleValidation();
      // const isDuplicateScName = this.checkDuplicateScorecardName()
      let self = this;
      let data = this.handleRequestParam();
      let endpointName = "";
      if (isError || isValid) {
        this.setState({ scorecardErrorModel: true });
      } else {
        /* else if(isDuplicateScName) {
        this.setState({ duplicateScorecard: true })
      } 
      */
        data.type =
          utils.getSessionItem("role") === RoleConstant.Admin
            ? "USER_ASSIGN_TO_ADMIN"
            : "ADMIN_ASSIGN_TO_OTHER_ADMIN";
        data.questionsetid = this.state.questionsetid;
        data.questionsetName = this.state.questionsetName;
        data.assignedToAdmin = this.state.selectedAdmin;
        data.isPassed = this.state.isPassed;
        data.finalScore = this.state.finalScore;
        data.updatedScore = this.state.updatedScore;
        data.questionStatus = this.state.questionStatus;
        data.questionset = this.state.questionset;
        const assignedUser = this.state.adminUsers.filter(
          (val) => val.id == this.state.selectedAdmin
        );
        data.assignedToAdminName = assignedUser.length
          ? `${assignedUser[0].firstName} ${assignedUser[0].lastName}`
          : "";
        data.assignedToRole = assignedUser.length
          ? `${assignedUser[0].role}`
          : this.state.selectedAdmin;
        data.createdByRole = utils.getSessionItem("role");
        // data.comments = this.state.newcomment
        //   ? this.state.newcomment
        //   : this.state.comment[this.state.comment.length - 1]?.status === "Saved"
        //     ? this.state.comment[this.state.comment.length - 1]?.comments
        //     : this.state.newcomment;
        data.comments = this.state.newcomment;

        endpointName =
          this.props.scoreCard === "new" && !this.state.scorecardId
            ? EndpointConstant.ADD_SCORE_CARD
            : EndpointConstant.UPDATE_SCORECARD;
        //  return;
        if (data.assignedToRole == "Reviewer") {
          data.isAssignedToReviewer = true;
        } else {
          data.isAssignedToReviewer = false;
        }
        if (this.state.scorecardId || this.props.scoreCard === "edit") {
          data.previousAssignedToAdminName =
            this.state.previousAssignedToAdminName;
          data.previousAssignedToAdmin = this.state.previousAssignedToAdmin;
          data.previousAssignedToName = this.state.previousAssignedToName;
          data.previousAssignedTo = this.state.previousAssignedTo;
          // data.comments = this.state.comment[this.state.comment.length - 1]?.comments || "";
        }
        data.__isAutoSave = isAutoSave;

        utils.makeRequest(this, endpointName, data, function (result) {
          if (result.error === false || result.error === "false") {
            self.setState({
              scorecardUpdateModel: true,
              isComplete: false,
              isDraft: false,
              scorecardId: result.scorecardId,
              formChanged: false, // reset change flag
              isAutoSave: false
            });
          }
        });
      }
    }
    catch (err) {
      if (this.savingMessageShown) {
        this.hideSavingMessage(this.SAVING_KEY);
        this.savingMessageShown = false;
      }
      this.showMessage("Save failed or took too long. Please try again.", "error");
    } finally {
      this.setState({ blockingNav: false, formDisabled: false });
    }
  }

  completeScorecard = async(value) => {
    try {
      if (this.isUpdateSaveInFlight || this.saveInFlight || this.autoSaveTimer) {
        this.setState({ blockingNav: true });
        utils.showLoader();
        if (!this.savingMessageShown) {
          this.showSavingMessage('Scorecard saving is in progress...', this.SAVING_KEY);
          this.savingMessageShown = true;
        }
        await this.flushAutoSaveAndWait();
        utils.hideLoader()
        if (this.savingMessageShown) {
          this.hideSavingMessage(this.SAVING_KEY);
          this.savingMessageShown = false;
        }
      }

    const isAutoSave = value === true; // explicit mode
    
    if (value === false) {
      await new Promise((resolve) => {
        this.setState({ isAutoSave: false }, resolve);
      });
    }
    
    let self = this;
    const isError = this.handleScorecardValidation();
    const isValid = this.handleValidation();
    // const isDuplicateScName = this.checkDuplicateScorecardName()
    if (isError || isValid) {
      this.setState({ scorecardErrorModel: true });
    } else {
      /* else if(isDuplicateScName) {
      this.setState({ duplicateScorecard: true })
    } */
      let data = this.handleRequestParam(false);
      // console.log("in 233:"+JSON.stringify(data))
      data.type = "ADMIN_ASSIGN_TO_ADMIN";
      // if(this.props.scoreCard === 'new') {
      data.status = "Completed";
      data.questionsetid = this.state.questionsetid;
      data.questionsetName = this.state.questionsetName;
      data.assignedToAdmin = ""; // this.state.createdBy;
      data.assignedToAdminName = ""; // this.state.assignedToName;
      data.ScorecardName = this.state.ScorecardName;
      data.isPassed = this.state.isPassed;
      data.updatedScore = this.state.updatedScore;
      data.finalScore = this.state.finalScore;
      data.questionStatus = this.state.questionStatus;
      data.questionset = this.state.questionset;
      // data.comments = this.state.newcomment
      //   ? this.state.newcomment
      //   : this.state.comment[this.state.comment.length - 1]?.status === "Saved"
      //     ? this.state.comment[this.state.comment.length - 1]?.comments
      //     : this.state.newcomment;
      data.comments = this.state.newcomment;
      // }
      if (this.state.scorecardId || this.props.scoreCard === "edit") {
        data.previousAssignedToAdminName =
          this.state.previousAssignedToAdminName;
        data.previousAssignedToAdmin = this.state.previousAssignedToAdmin;
        data.previousAssignedToName = this.state.previousAssignedToName;
        data.previousAssignedTo = this.state.previousAssignedTo;
        data.ScorecardName = this.state.ScorecardName;
        data.isPassed = this.state.isPassed;
        data.finalScore = this.state.finalScore;
        data.updatedScore = this.state.updatedScore;
        data.questionStatus = this.state.questionStatus;
        data.questionset = this.state.questionset;
        // data.comments = this.state.comment[this.state.comment.length - 1]?.comments || "";
      }      
      data.__isAutoSave = isAutoSave;

      let endpoint =
        this.props.scoreCard === "new" && !this.state.scorecardId
          ? EndpointConstant.ADD_SCORE_CARD
          : EndpointConstant.UPDATE_SCORECARD;
      // console.log("data in 245:"+JSON.stringify(data));
      // console.log("Data in 246:"+JSON.stringify(data.scorecards));
      utils.makeRequest(this, endpoint, data, function (result) {
        if (result.error === false || result.error === "false") {
          if (self._isMounted) {
            self.setState({
              scorecardUpdateModel: true,
              isComplete: true,
              isDraft: false,
              scorecardId: result.scorecardId,
              formChanged: false, // reset change flag
              isAutoSave: false
            });
          }
        }
      });
    }
  }
    catch (err) {
      if (this.savingMessageShown) {
        this.hideSavingMessage(this.SAVING_KEY);
        this.savingMessageShown = false;
      }
      this.showMessage("Save failed or took too long. Please try again.", "error");
    } finally {
      this.setState({ blockingNav: false, formDisabled: false });
    }
}

saveScorecard = async (value) => {
  const isAutoSave = value === true;

  if (value === false) {
    await new Promise((resolve) => this.setState({ isAutoSave: false }, resolve));
  }

  if (isAutoSave && !this.state.formChanged) return Promise.resolve({ skipped: true });

  let createdNow = false;
  if (!this.state.scorecardId && this.props.scoreCard === "new") {
    const { created } = await this.ensureScorecardId(isAutoSave);
    createdNow = created;
  }

  if (createdNow && isAutoSave) return Promise.resolve({ created: true });

  const full = this.handleRequestParam(false);
  full.scorecardId = this.state.scorecardId;
  this.applyCommonFields(full, isAutoSave);

  return this.performSave(full, isAutoSave); 
};

 
  ensureScorecardId = async (isAutoSave) => {
    if (this.state.scorecardId) return { id: this.state.scorecardId, created: false };

    if (this._ensureIdPromise) return this._ensureIdPromise;

    const createPayload = this.handleRequestParam(true);
    this.applyCommonFields(createPayload, isAutoSave);

    const requestMethod = this.state.isAutoSave
      ? utils.makeRequestInBackground
      : utils.makeRequest;

    const endpoint = EndpointConstant.ADD_SCORE_CARD;    

    this.showSavingMessage('Scorecard creation is in progress...'); 

    this._ensureIdPromise = new Promise((resolve, reject) => {
      requestMethod(this, endpoint, createPayload, (result) => {
        try {
          this.hideSavingMessage(); 

          if (result && (result.error === false || result.error === "false")) {
            const newId = result.scorecardId || result.id;

            this.setState(
              {
                scorecardUpdateModel: this.state.isAutoSave ? false : true,
                isComplete: false,
                isDraft: true,
                scorecardId: newId,
                formChanged: false,
              },
              () => {
                if (isAutoSave) {
                  this.showMessage("Scorecard created successfully");
                  this.handleUpdateClose?.(true);
                }
                const baseline = this.handleRequestParam(false);
                baseline.scorecardId = newId;
                this.applyCommonFields(baseline, true);
                this.lastSavedSnapshot = baseline;
                this.lastSaveAt = Date.now();

                resolve({ id: newId, created: true });
              }
            );
          } else {
            const msg = (result && result.message) || "Create scorecard failed";
            this.showMessage(msg, "error");
            reject(new Error(msg));
          }
        } catch (err) {
          this.hideSavingMessage();
          this.showMessage("Create scorecard failed", "error");
          reject(err);
        }
      });
    })
      .catch((err) => {
        this.hideSavingMessage();
        throw err;
      })
      .finally(() => {
        this._ensureIdPromise = null;
      });

    return this._ensureIdPromise;
  };

applyCommonFields = (data, isAutoSave) => {
  data.status = "Saved";
  data.type = "ADMIN_ASSIGN_TO_ADMIN";
  data.questionsetid = this.state.questionsetid;
  data.questionsetName = this.state.questionsetName;
  data.assignedToAdmin = utils.getSessionItem("userId");
  data.assignedToAdminName = "";
  data.ScorecardName = this.state.ScorecardName;
  data.isPassed = this.state.isPassed;
  data.updatedScore = this.state.updatedScore;
  data.finalScore = this.state.finalScore;
  data.questionStatus = this.state.questionStatus;
  data.questionset = this.state.questionset;
  data.userId = utils.getSessionItem("userId");

  // data.comments = this.state.newcomment
  //   ? this.state.newcomment
  //   : this.state.comment[this.state.comment.length - 1]?.status === "Saved"
  //     ? this.state.comment[this.state.comment.length - 1]?.comments
  //     : this.state.newcomment;
  data.comments = this.state.newcomment;

  if (this.state.scorecardId || this.props.scoreCard === "edit") {
    data.previousAssignedToAdminName = this.state.previousAssignedToAdminName;
    data.previousAssignedToAdmin = this.state.previousAssignedToAdmin;
    data.previousAssignedToName = this.state.previousAssignedToName;
    data.previousAssignedTo = this.state.previousAssignedTo;
  }

  if (this.state.createdBy !== utils.getSessionItem("userId")) {
    data.createdBy = this.state.createBy;
  }

  data.__isAutoSave = isAutoSave;
  return data;
};

handleRequestParam(isCreate = false) {
  let data = {};

  if (isCreate || (!this.state.scorecardId && this.props.scoreCard === "new")) {
    data = { ...this.state };

    delete data.className;
    delete data.createdAt;
    delete data.modifiedAt;
    delete data.valid;
    delete data.id;
    delete data.agentNotes;
    delete data.questionsets;
    delete data.adminUsers;
    delete data.roleArr;
    delete data.userDetails;
    delete data.scorecards;
    delete data.scorecardQuestionDetails;
    delete data.AEID;
    delete data.AEID_Q2_AE_Error_Reconciliation;
    delete data.AEID_Q2_AE_Missed;
    delete data.AEID_Q2_AE_Missed_Amgen;
    delete data.AEID_Q2_AE_Missed_QualityMonitorQC;
    delete data.AEID_Q2_AE_Missed_QualityMonitorQC_Error;
    delete data.AE_Cap_IRPC_Match;
    delete data.AE_Cap_IRPC_Match_Amgen;
    delete data.AE_Cap_IRPC_Match_Error_Reconciliation;
    delete data.AE_Cap_IRPC_Match_QualityMonitorQC;
    delete data.AE_Cap_IRPC_Match_QualityMonitorQC_Error;
    delete data.AE_Q2_HCP;
    delete data.AE_Q2_HCP_Amgen;
    delete data.AE_Q2_HCP_Error_Reconciliation;
    delete data.AE_Q2_HCP_QualityMonitorQC;
    delete data.AE_Q2_HCP_QualityMonitorQC_Error;
    delete data.AE_Q3_IPRC;
    delete data.AE_Q3_IPRC_Amgen;
    delete data.AE_Q3_IPRC_Error_Reconciliation;
    delete data.AE_Q3_IPRC_QualityMonitorQC;
    delete data.AE_Q3_IPRC_QualityMonitorQC_Error;
    delete data.IRPCContactName;
    delete data.MIRDescription;
    delete data.MIRID;
    delete data.PCID_Q2_Missed;
    delete data.PCID_Q2_Missed_Amgen;
    delete data.PCID_Q2_Missed_Error_Reconciliation;
    delete data.PCID_Q2_Missed_QualityMonitorQC;
    delete data.PCID_Q2_Missed_QualityMonitorQC_Error;
    delete data.PCMRID;
    delete data.PC_Q1_IPRC_Match_Amgen;
    delete data.PC_Q1_IPRC_Match_QualityMonitorQC_Error;

    data.interactionId = this.state.id;
    data.ScorecardName = this.state.ScorecardName;

    data.comments = this.state.newcomment;
    this.setState({ valid: true });
    return data;
  }
  data.questionaries = this.state.questionaries;
  data.id = this.state.id;
  data.interactionId = this.state.interactionId;
  data.datasetId = this.state.datasetId;
  data.product = this.state.product;
  data.questionStatus = this.state.questionStatus;
  data.ScorecardName = this.state.ScorecardName;
  data.finalScore = this.state.finalScore;
  data.questionStatus = this.state.questionStatus;
  data.questionset = this.state.questionset;

  data.comments = this.state.newcomment;
  this.setState({ valid: true });
  return data;
}

performSave = (payload, isAutoSave) => {
  if (this.saveInFlight) {
    this.savePending = true;
    this.latestSavePayload = payload;
    return this.lastSavePromise || Promise.resolve();
  }

  const endpoint =
    !this.state.scorecardId && this.props.scoreCard === "new"
      ? EndpointConstant.ADD_SCORE_CARD
      : EndpointConstant.UPDATE_SCORECARD;

  const isUpdateEndpoint = endpoint === EndpointConstant.UPDATE_SCORECARD;
  if (isUpdateEndpoint) {
    this.isUpdateSaveInFlight = true;
  }

  this.saveInFlight = true;
  const seq = ++this.saveSeq;

  this.showSavingMessage('Scorecard saving is in progress...', this.SAVING_KEY);

  this.lastSavePromise = this.requestAsPromise(isAutoSave, endpoint, payload)
    .then((result) => {
      if (seq < this.saveSeq) {
        return { stale: true };
      }

      this.lastAppliedSeq = seq;
      this.lastSaveWasAuto = isAutoSave;

      const newId = result.scorecardId || result.id || this.state.scorecardId;
      this.hideSavingMessage(this.SAVING_KEY);
      return new Promise((resolve) => {
        if (isAutoSave) {
          this.showMessage("Scorecard has been saved successfully");
        }

        this.setState(
          {
            scorecardUpdateModel: this.state.isAutoSave ? false : true,
            isComplete: false,
            isDraft: true,
            scorecardId: newId,
            formChanged: false,
          },
          () => {
            this.lastSaveAt = Date.now();

            const baseline = this.handleRequestParam(false);
            baseline.scorecardId = this.state.scorecardId;
            this.applyCommonFields(baseline, /* isAutoSave */ true);
            this.lastSavedSnapshot = baseline;

            const newVersion = result.version ?? (this.state.scorecardVersion ?? 0) + 1;
            this.setState({ scorecardVersion: newVersion });

            resolve({ ok: true, result });
          }
        );
      });
    })
    .catch((err) => {
      if (isAutoSave) {
        this.showMessage("Auto-save failed!", "error");
      }
      throw err;
    })
    .finally(() => {
      this.saveInFlight = false;

      if (isUpdateEndpoint) {
        this.isUpdateSaveInFlight = false;
      }

      if (this.savePending) {
        const next = this.latestSavePayload;
        this.savePending = false;
        this.lastSavePromise = this.performSave(next, /* isAutoSave */ true);
      }
    });

  return this.lastSavePromise;
};

  handleScorecardValidation() {
    const questions = this.state.questionaries;
    // const scorecardName = this.state.ScorecardName
    let UnansweredQns = questions.filter(
      (val) => val.answer === undefined || !val.answer.length
    );
    let UnansweredScore = this.state.updatedScore.filter(
      (val) => val.value === "" 
    );
    // let emptySCName = !scorecardName.length
    if (UnansweredQns.length) {
      for (let i = 0; i < UnansweredQns.length; i++) {
        if (document.getElementById(UnansweredQns[i].id)) {
          document.getElementById(UnansweredQns[i].id).classList.add("invalid");
        }
      }
    }
    if (UnansweredScore.length) {
      for (let i = 0; i < UnansweredScore.length; i++) {
        if (document.getElementById(`score-${UnansweredScore[i].id}`)) {
          document.getElementById(`score-${UnansweredScore[i].id}`).classList.add("invalid");
        }
      }
    }
    return UnansweredQns.length === 0 && UnansweredScore.length === 0 ? false : true;
  }

  handleValidation() {
    if (!this.state.product) {
      // alert(this.state.product.length);
      let esclass = document.getElementById("product").getAttribute("class");
      if (document.getElementById("product").value.trim() === "") {
        document
          .getElementById("product")
          .setAttribute("class", esclass + " invalid");
      }
      let esclass1 = document
        .getElementById("quesStatus")
        .getAttribute("class");
      if (document.getElementById("quesStatus").value.trim() === "") {
        document
          .getElementById("quesStatus")
          .setAttribute("class", esclass1 + " invalid");
      }

      return true;
    } else {
      return false;
    }
  }

  handleExtractValidationClose() {
    this.setState({
      extractValidation: false,
      extractErrMsg: "",
    });
  }

  handleErrorClose() {
    this.setState({ scorecardErrorModel: false });
  }
  handleNoUserErrorClose() {
    this.setState({ scorecardNoUserError: false });
  }
  handleDuplicateSCNameError() {
    this.setState({ duplicateScorecard: false });
  }
  
 handleUpdateClose = (isViewDetails) => {
  return new Promise((resolve) => {
    const data = { id: this.state.scorecardId };
    const requestMethod = utils.makeRequest;

    requestMethod(this, EndpointConstant.SCORECARD_DETAILS, data, (result) => {
      const scorecardDetails = result.scorecardDetails;
      this.loading = false;

      scorecardDetails[0].datasetName =
        this.props.scoreCard === "new"
          ? this.props.details.datasetNameView
          : this.props.details.datasetName;

      scorecardDetails[0].cardNew =
        this.props.scoreCard === "new"
          ? ""
          : this.props.details.ScorecardName;

      this.setState(
        {
          id: this.state.isAutoSave ? scorecardDetails[0].id : this.state.id,
          interactionId: this.state.isAutoSave
            ? scorecardDetails[0].interactionId
            : this.state.interactionId,
          scorecardDetails: scorecardDetails,
          scorecardUpdateModel: false,
          isComplete: false,
          showViewDetails: isViewDetails ? false : true
        },
        // () => {
        //   if (isAutoSave) {
        //     this.showMessage("Auto-save successful!", "success");
        //   }
        //   resolve(); 
        // }
      );
    });
  });
};
  caliculation() {
    let count = {
      trueCount: 0,
      falseCount: 0,
    };
    //  let trueCount=0
    //  let falseCount=0
    if (this.state.AEID_Q2_AE_Error_Reconciliation === "True") {
      count.trueCount = ++count.trueCount;
    }
    if (this.state.AEID_Q2_AE_Error_Reconciliation === "False") {
      count.falseCount = ++count.falseCount;
    }
    if (this.state.AE_Cap_IRPC_Match_Error_Reconciliation === "True") {
      count.trueCount = ++count.trueCount;
    }
    if (this.state.AE_Cap_IRPC_Match_Error_Reconciliation === "False") {
      count.falseCount = ++count.falseCount;
    }
    if (this.state.AE_Q2_HCP_Error_Reconciliation === "True") {
      count.trueCount = ++count.trueCount;
    }
    if (this.state.AE_Q2_HCP_Error_Reconciliation === "False") {
      count.falseCount = ++count.falseCount;
    }
    if (this.state.AE_Q3_IPRC_Error_Reconciliation === "True") {
      count.trueCount = ++count.trueCount;
    }
    if (this.state.AE_Q3_IPRC_Error_Reconciliation === "False") {
      count.falseCount = ++count.falseCount;
    }
    if (this.state.PCID_Q2_Missed_Error_Reconciliation === "True") {
      count.trueCount = ++count.trueCount;
    }
    if (this.state.PCID_Q2_Missed_Error_Reconciliation === "False") {
      count.falseCount = ++count.falseCount;
    }
    if (this.state.PC_Q1_IPRC_Error_Reconciliation === "True") {
      count.trueCount = ++count.trueCount;
    }
    if (this.state.PC_Q1_IPRC_Error_Reconciliation === "False") {
      count.falseCount = ++count.falseCount;
    }
    if (
      this.state
        .bioconnect_Match_capturedIn_probing_decisionTree_Error_Reconciliation ===
      "True"
    ) {
      count.trueCount = ++count.trueCount;
    }
    if (
      this.state
        .bioconnect_Match_capturedIn_probing_decisionTree_Error_Reconciliation ===
      "False"
    ) {
      count.falseCount = ++count.falseCount;
    }
    return count;
  }
  aeidMatch() {
    if (
      this.state.AEID_Q2_AE_Missed_QualityMonitorQC !== undefined &&
      this.state.AEID_Q2_AE_Missed_QualityMonitorQC !== "" &&
      this.state.AEID_Q2_AE_Missed_Amgen !== "" &&
      this.state.AEID_Q2_AE_Missed_Amgen !== undefined
    ) {
      if (
        this.state.AEID_Q2_AE_Missed_QualityMonitorQC ===
        this.state.AEID_Q2_AE_Missed_Amgen
      ) {
        this.setState({ AEID_Q2_AE_Error_Reconciliation: "True" }, () => {
          let count = this.caliculation();
          this.setState({ Total_Error_Reconciliation: count.trueCount });
          if (count.trueCount !== 0) {
            let percentage = (count.trueCount / 7) * 100;
            this.setState({ Quality_Percentage_INT: percentage });
          }
        });
      } else {
        this.setState({ AEID_Q2_AE_Error_Reconciliation: "False" }, () => {
          let count = this.caliculation();
          this.setState({ Total_Error_Reconciliation: count.trueCount });
          if (count.trueCount !== 0) {
            let percentage = (count.trueCount / 7) * 100;
            this.setState({ Quality_Percentage_INT: percentage });
          }
        });
      }
    } else {
      this.setState({ AEID_Q2_AE_Error_Reconciliation: "-" }, () => {
        let count = this.caliculation();
        this.setState({ Total_Error_Reconciliation: count.trueCount });
        if (count.trueCount !== 0) {
          let percentage = (count.trueCount / 7) * 100;
          this.setState({ Quality_Percentage_INT: percentage });
        }
      });
    }
  }
  AE_Cap_IRPC_Match() {
    if (
      this.state.AE_Cap_IRPC_Match_QualityMonitorQC !== undefined &&
      this.state.AE_Cap_IRPC_Match_QualityMonitorQC !== "" &&
      this.state.AE_Cap_IRPC_Match_Amgen !== "" &&
      this.state.AE_Cap_IRPC_Match_Amgen !== undefined
    ) {
      if (
        this.state.AE_Cap_IRPC_Match_QualityMonitorQC ===
        this.state.AE_Cap_IRPC_Match_Amgen
      ) {
        this.setState(
          { AE_Cap_IRPC_Match_Error_Reconciliation: "True" },
          () => {
            let count = this.caliculation();
            this.setState({ Total_Error_Reconciliation: count.trueCount });
            if (count.trueCount !== 0) {
              let percentage = (count.trueCount / 7) * 100;
              this.setState({ Quality_Percentage_INT: percentage });
            }
          }
        );
      } else {
        this.setState(
          { AE_Cap_IRPC_Match_Error_Reconciliation: "False" },
          () => {
            let count = this.caliculation();
            this.setState({ Total_Error_Reconciliation: count.trueCount });
            if (count.trueCount !== 0) {
              let percentage = (count.trueCount / 7) * 100;
              this.setState({ Quality_Percentage_INT: percentage });
            }
          }
        );
      }
    } else {
      this.setState({ AE_Cap_IRPC_Match_Error_Reconciliation: "-" }, () => {
        let count = this.caliculation();
        this.setState({ Total_Error_Reconciliation: count.trueCount });
        if (count.trueCount !== 0) {
          let percentage = (count.trueCount / 7) * 100;
          this.setState({ Quality_Percentage_INT: percentage });
        }
      });
    }
  }
  AE_Q2_HCP() {
    if (
      this.state.AE_Q2_HCP_QualityMonitorQC !== undefined &&
      this.state.AE_Q2_HCP_QualityMonitorQC !== "" &&
      this.state.AE_Q2_HCP_Amgen !== "" &&
      this.state.AE_Q2_HCP_Amgen !== undefined
    ) {
      if (
        this.state.AE_Q2_HCP_QualityMonitorQC === this.state.AE_Q2_HCP_Amgen
      ) {
        this.setState({ AE_Q2_HCP_Error_Reconciliation: "True" }, () => {
          let count = this.caliculation();
          this.setState({ Total_Error_Reconciliation: count.trueCount });
          if (count.trueCount !== 0) {
            let percentage = (count.trueCount / 7) * 100;
            this.setState({ Quality_Percentage_INT: percentage });
          }
        });
      } else {
        this.setState({ AE_Q2_HCP_Error_Reconciliation: "False" }, () => {
          let count = this.caliculation();
          this.setState({ Total_Error_Reconciliation: count.trueCount });
          if (count.trueCount !== 0) {
            let percentage = (count.trueCount / 7) * 100;
            this.setState({ Quality_Percentage_INT: percentage });
          }
        });
      }
    } else {
      this.setState({ AE_Q2_HCP_Error_Reconciliation: "-" }, () => {
        let count = this.caliculation();
        this.setState({ Total_Error_Reconciliation: count.trueCount });
        if (count.trueCount !== 0) {
          let percentage = (count.trueCount / 7) * 100;
          this.setState({ Quality_Percentage_INT: percentage });
        }
      });
    }
  }
  AE_Q3_IPRC() {
    if (
      this.state.AE_Q3_IPRC_QualityMonitorQC !== undefined &&
      this.state.AE_Q3_IPRC_QualityMonitorQC !== "" &&
      this.state.AE_Q3_IPRC_Amgen !== "" &&
      this.state.AE_Q3_IPRC_Amgen !== undefined
    ) {
      if (
        this.state.AE_Q3_IPRC_QualityMonitorQC === this.state.AE_Q3_IPRC_Amgen
      ) {
        this.setState({ AE_Q3_IPRC_Error_Reconciliation: "True" }, () => {
          let count = this.caliculation();
          this.setState({ Total_Error_Reconciliation: count.trueCount });
          if (count.trueCount !== 0) {
            let percentage = (count.trueCount / 7) * 100;
            this.setState({ Quality_Percentage_INT: percentage });
          }
        });
      } else {
        this.setState({ AE_Q3_IPRC_Error_Reconciliation: "False" }, () => {
          let count = this.caliculation();
          this.setState({ Total_Error_Reconciliation: count.trueCount });
          if (count.trueCount !== 0) {
            let percentage = (count.trueCount / 7) * 100;
            this.setState({ Quality_Percentage_INT: percentage });
          }
        });
      }
    } else {
      this.setState({ AE_Q3_IPRC_Error_Reconciliation: "-" }, () => {
        let count = this.caliculation();
        this.setState({ Total_Error_Reconciliation: count.trueCount });
        if (count.trueCount !== 0) {
          let percentage = (count.trueCount / 7) * 100;
          this.setState({ Quality_Percentage_INT: percentage });
        }
      });
    }
  }
  PCID_Q2_Missed() {
    if (
      this.state.PCID_Q2_Missed_QualityMonitorQC !== undefined &&
      this.state.PCID_Q2_Missed_QualityMonitorQC !== "" &&
      this.state.PCID_Q2_Missed_Amgen !== "" &&
      this.state.PCID_Q2_Missed_Amgen !== undefined
    ) {
      if (
        this.state.PCID_Q2_Missed_QualityMonitorQC ===
        this.state.PCID_Q2_Missed_Amgen
      ) {
        this.setState({ PCID_Q2_Missed_Error_Reconciliation: "True" }, () => {
          let count = this.caliculation();
          this.setState({ Total_Error_Reconciliation: count.trueCount });
          if (count.trueCount !== 0) {
            let percentage = (count.trueCount / 7) * 100;
            this.setState({ Quality_Percentage_INT: percentage });
          }
        });
      } else {
        this.setState({ PCID_Q2_Missed_Error_Reconciliation: "False" }, () => {
          let count = this.caliculation();
          this.setState({ Total_Error_Reconciliation: count.trueCount });
          if (count.trueCount !== 0) {
            let percentage = (count.trueCount / 7) * 100;
            this.setState({ Quality_Percentage_INT: percentage });
          }
        });
      }
    } else {
      this.setState({ PCID_Q2_Missed_Error_Reconciliation: "-" }, () => {
        let count = this.caliculation();
        this.setState({ Total_Error_Reconciliation: count.trueCount });
        if (count.trueCount !== 0) {
          let percentage = (count.trueCount / 7) * 100;
          this.setState({ Quality_Percentage_INT: percentage });
        }
      });
    }
  }
  PC_Q1_IPRC_Match() {
    if (
      this.state.PC_Q1_IPRC_Match_QualityMonitorQC !== undefined &&
      this.state.PC_Q1_IPRC_Match_QualityMonitorQC !== "" &&
      this.state.PC_Q1_IPRC_Match_Amgen !== "" &&
      this.state.PC_Q1_IPRC_Match_Amgen !== undefined
    ) {
      if (
        this.state.PC_Q1_IPRC_Match_QualityMonitorQC ===
        this.state.PC_Q1_IPRC_Match_Amgen
      ) {
        this.setState({ PC_Q1_IPRC_Error_Reconciliation: "True" }, () => {
          let count = this.caliculation();
          this.setState({ Total_Error_Reconciliation: count.trueCount });
          if (count.trueCount !== 0) {
            let percentage = (count.trueCount / 7) * 100;
            this.setState({ Quality_Percentage_INT: percentage });
          }
        });
      } else {
        this.setState({ PC_Q1_IPRC_Error_Reconciliation: "False" }, () => {
          let count = this.caliculation();
          this.setState({ Total_Error_Reconciliation: count.trueCount });
          if (count.trueCount !== 0) {
            let percentage = (count.trueCount / 7) * 100;
            this.setState({ Quality_Percentage_INT: percentage });
          }
        });
      }
    } else {
      this.setState({ PC_Q1_IPRC_Error_Reconciliation: "-" }, () => {
        let count = this.caliculation();
        this.setState({ Total_Error_Reconciliation: count.trueCount });
        if (count.trueCount !== 0) {
          let percentage = (count.trueCount / 7) * 100;
          this.setState({ Quality_Percentage_INT: percentage });
        }
      });
    }
  }
  bioconnect_Match_capturedIn_probing_decisionTree_originalQM() {
    if (
      this.state
        .bioconnect_Match_capturedIn_probing_decisionTree_QualityMonitorQC !==
      undefined &&
      this.state
        .bioconnect_Match_capturedIn_probing_decisionTree_QualityMonitorQC !==
      "" &&
      this.state.bioconnect_Match_capturedIn_probing_decisionTree_amgenQC !==
      "" &&
      this.state.bioconnect_Match_capturedIn_probing_decisionTree_amgenQC !==
      undefined
    ) {
      if (
        this.state
          .bioconnect_Match_capturedIn_probing_decisionTree_QualityMonitorQC ===
        this.state.bioconnect_Match_capturedIn_probing_decisionTree_amgenQC
      ) {
        this.setState(
          {
            bioconnect_Match_capturedIn_probing_decisionTree_Error_Reconciliation:
              "True",
          },
          () => {
            let count = this.caliculation();
            this.setState({ Total_Error_Reconciliation: count.trueCount });
            if (count.trueCount !== 0) {
              let percentage = (count.trueCount / 7) * 100;
              this.setState({ Quality_Percentage_INT: percentage });
            }
          }
        );
      } else {
        this.setState(
          {
            bioconnect_Match_capturedIn_probing_decisionTree_Error_Reconciliation:
              "False",
          },
          () => {
            let count = this.caliculation();
            this.setState({ Total_Error_Reconciliation: count.trueCount });
            if (count.trueCount !== 0) {
              let percentage = (count.trueCount / 7) * 100;
              this.setState({ Quality_Percentage_INT: percentage });
            }
          }
        );
      }
    } else {
      this.setState(
        {
          bioconnect_Match_capturedIn_probing_decisionTree_Error_Reconciliation:
            "-",
        },
        () => {
          let count = this.caliculation();
          this.setState({ Total_Error_Reconciliation: count.trueCount });
          if (count.trueCount !== 0) {
            let percentage = (count.trueCount / 7) * 100;
            this.setState({ Quality_Percentage_INT: percentage });
          }
        }
      );
    }
  }

  calculateFinalScore = () => {
    const questionSet = this.state.questionset &&
      this.state.questionset.questionaries.some(q => q.hasOwnProperty("numericWeightage"))
    if (!questionSet) return;

    const hasNullValues = this.state.updatedScore.every(item => item.value === '' || item.value === null || item.value === undefined);
    if(hasNullValues){
    this.setState({
      finalScore: "",
      questionStatus: "",
    })
    return;
   }
    const totalWeightage = this.state.updatedScore.reduce((sum, q) => {
      return sum + parseInt(q.value || "0", 10);
    }, 0);
    const threshold = this.state.questionset.thresholdValue;
    let questionStatus = "N/A";
    if (!parseInt(threshold) || isNaN(parseInt(threshold))) {
      questionStatus = "N/A";
    } else if (totalWeightage >= parseInt(threshold)) {
      questionStatus = "pass";
    } else {
      questionStatus = "fail";
    }

    this.setState({
      finalScore: totalWeightage,
      questionStatus: questionStatus,
    });
  };

  handleScoreChange = (e, score) => {
    const rawValue = e.target.value;

    // Allow empty input
    if (rawValue === '') {
      this.updateScoreState(score.id, '');
      return;
    }

    const value = parseInt(rawValue, 10);
    const max = parseInt(score.numericWeightage, 10);

    // Validation
    if (value > max) {
      this.setState({
        extractValidation: true,
        extractErrMsg: "Score should not be greater than weightage",
      });
      return;
    } else if (value < 0) {
      this.setState({
        extractValidation: true,
        extractErrMsg: "Score should not be less than zero",
      });
      return;
    }
    this.updateScoreState(score.id, value);
  };


  updateScoreState = (id, value) => {
    this.setState((prevState) => {
      const existing = prevState.updatedScore.find((item) => item.id === id);

      let updated;
      if (existing) {
        updated = prevState.updatedScore.map((item) =>
          item.id === id ? { ...item, value } : item
        );
      } else {
        updated = [...prevState.updatedScore, { id, value }];
      }

    return {
      updatedScore: updated,
      formChanged: true,  
      isAutoSave: true       
    };
  }, () => {
    this.calculateFinalScore();

    this.triggerAutoSave();
  });
};


  getCurrentValue = (score) => {
    const updated = this.state.updatedScore.find((item) => item.id === score.id);
    return updated ? updated.value : "";
  };

handleChangeYesNo(e, question, id) {
    e.persist();
    if (id) {
      const questions = this.state.questionaries.length
        ? this.state.questionaries
        : this.state.questionaries;
      questions.map((values, i) => {
        if (values.id === id) {
          questions[i].answer = e.target.value;
        }
        return values;
      });
      this.setState({
        questionaries: questions, formChanged: true, isAutoSave: true
      }, () => {
        this.calculateFinalScore();
          this.triggerAutoSave();
      });
      e.target.classList.remove("invalid");
    } else {
      this.setState({ [e.target.name]: e.target.value, formChanged: true, isAutoSave: true });
      if (this.state.scorecardId && e.target.name === "product")
        this.triggerAutoSave();
      e.target.classList.remove("invalid");
    }
  }

  // handleCommentsChange = (event) => {
  //   const { name, value } = event.target;
  //   // console.log(value);

  //   if (name === "newcomment") {
  //     this.setState({ newcomment: value });
  //   }
  //   const updatedCommentHist = [...this.state.comment];
  //   // console.log("1012",updatedCommentHist)

  //   if (updatedCommentHist.length > 0) {
  //     updatedCommentHist[updatedCommentHist.length - 1].comments = value;
  //   } else {
  //     updatedCommentHist.push({ comments: value });
  //   }
  //   this.setState({ comment: updatedCommentHist, formChanged: true, isAutoSave: true });
  //   this.triggerAutoSave();
  // };

  handleCommentsChange = (event) => {
  const { value } = event.target;

  this.setState(
    {
      newcomment: value,
      formChanged: true,
      isAutoSave: true,
    },
    () => this.triggerAutoSave()
  );
};
  questionsetNameChanges(e) {
    e.persist();
    const selectedSetId = e.target.value;

    // If the selected question set is the same, do nothing
    if (selectedSetId === this.state.questionsetid) {
      return;
    }

    const questionSet = Array.isArray(this.state.questionsets) &&
      this.state.questionsets.find(qs => qs.id === selectedSetId);

    if (!questionSet) return;

    const Score = []
    questionSet.questionaries.map((a, id) => { Score[id] = { id: a.id, value: "" } })

    const Questionaries = questionSet.questionaries.map(q => ({
      ...q,
      answer: "", // Reset answers only if question set changed
    }));
    const hasNumericWeightage = Questionaries?.some((q) =>
      q.hasOwnProperty("numericWeightage")
    );
    if (!hasNumericWeightage) {
      this.showAlertModal(`Some details in the selected questionset are incomplete, such as missing question weightage, case section, or passing score. Please update the "${questionSet.questionsetName}" questionset before proceeding with this scorecard.`);

      this.setState({  
        formChanged: false,  
        isAutoSave: false,   
        selectedQuestionset: "",
        questionsetName: "",
        questionsetid: "",
        questionaries: [],
        finalScore: 0,
        isPassed: false,
        questionStatus: "",
        showQuestionTable: false,        //  Hide question table
        showCommentsSection: false,      //  Hide comments
        showActionButtons: false         //  Hide Save/Complete/Submit buttons
      });
      return;
    }
    const totalWeightage = 0;
    const threshold = questionSet.thresholdValue;
    let status = "N/A";

    if (!threshold || isNaN(parseInt(threshold))) {
      status = "N/A";
    } else if (totalWeightage >= parseInt(threshold)) {
      status = "Pass";
    } else {
      status = "Fail";
    }

    this.setState({
      formChanged: true,
      isAutoSave: true,
      questionaries: Questionaries,
      questionset: questionSet,
      selectedQuestionset: selectedSetId,
      questionsetName: questionSet.questionsetName,
      questionsetid: questionSet.id,
      finalScore: "",
      isPassed: "",
      questionStatus: "",
      updatedScore: Score
    });
    this.triggerAutoSave();
  }


  showHistory() {
    this.setState({ showComment: true });
  }
  hideHistory() {
    this.setState({ showComment: false });
  }

  goBackToHome(type) {
    this.setState({ showViewDetails: false });
    this.props.goBackToHome(type);
  }

  showAdminDetails() {
    const isError = this.handleScorecardValidation();
    const isValid = this.handleValidation();
    // const isDuplicateScName = this.checkDuplicateScorecardName()

    if (isError || isValid) {
      this.setState({ scorecardErrorModel: true });
    } else {
      /* else if(isDuplicateScName) {
      this.setState({ duplicateScorecard: true })
    } */
      let data = { isScorecard: 1 };
      let self = this;
      utils.showLoader();
      utils.makeRequest(
        this,
        EndpointConstant.GET_USER_LIST,
        data,
        function (result) {
          utils.hideLoader();
          const users = result.users.filter(
            (val) =>
              val.status == "2" &&
              (val.role == RoleConstant.SuperAdmin ||
                val.role == RoleConstant.SAdmin ||
                val.role == RoleConstant.Reviewer)
          );
          self.setState({ adminUsers: users, showAdminPopup: true });
        }
      );
    }
  }

  handleAdminPopupClose() {
    this.setState({ showAdminPopup: false });
  }

  submitScorecard(value) {
    this.setState({ showAdminPopup: false });
    this.updateScorecard(value);
  }

  getScoreCardList() {
    let data = {
      datasetId: "All",
    };
    let self = this;
    utils.makeRequest(
      this,
      EndpointConstant.SCORECARDS_LISTS_FROM_DATASET,
      data,
      async function (result) {
        //utils.showLoader();
        await fetch(result.scorecards, {
          mode: "cors",
          headers: {
            "Access-Control-Allow-Origin": "*",
          },
          method: "GET",
          body: null,
        })
          .then((response) => response.json())
          .then((s3ResponseJson) => {
            const scorecards = s3ResponseJson;
            self.setState({ scorecards: scorecards });
            utils.hideLoader();
          })
          .catch((error) => {
            let er;
            // console.error(error);
            // console.log("Testing 12345 Error");
          });
      }
    );
  }

  checkDuplicateScorecardName() {
    if (this.props.scoreCard === "new") {
      const scorecards = this.state.scorecards;
      const scorecardName = this.state.ScorecardName.trim();
      return scorecards.some(
        (sc) => sc.ScorecardName.toUpperCase() === scorecardName.toUpperCase()
      );
    } else {
      return false;
    }
  }

  customFilter = (options, filter) => {
    if(!filter) return options;

    const search = filter.toLowerCase();

    return options.filter(option => 
      option.label.toLowerCase().includes(search)
    )
    .sort((a, b) => {
      const aLabel = a.label.toLowerCase();
      const bLabel = b.label.toLowerCase();

      const aStarts = aLabel.startsWith(search);
      const bStarts = bLabel.startsWith(search);

      if (aStarts && !bStarts) return -1;
      if (!aStarts && bStarts) return 1;
      return 0;

    });
  };

  render() {
  // const { showToast, toastMessage, toastType } = this.state;
    // this.isValidForm();
    // let scorecarDetails=this.props.details;       
    let isExistingQuestionset =
      this.state.questionsets.length &&
      this.state.questionsets.some(
        (val) => val.id === this.state.questionsetid
      );
    let questionsetOptions = [];
    const siteinfo = JSON.parse(utils.getSessionItem("SiteInfo"));
    if (this.state.questionsets.length > 0) {
      questionsetOptions = this.state.questionsets.map((question) => {
        // console.log("dataset", question)
        // return questionsetOptions.push({ id: question.id, label: question.questionsetName, value: question.id });
        return (
          <option key={question.id} value={question.id}>
            {question.questionsetName}
          </option>
        );
      });
    }
    //const currentUserId = utils.getSessionItem("userId");
    const ifrOptions = CommonService.ifrType.map((status, i) => {
      return (
        <option key={i} value={status.value}>
          {status.value}
        </option>
      );
    });
    const channelOptions = siteinfo.Channel.map((channel, i) => {
      return (
        <option key={i} value={channel}>
          {channel}
        </option>
      );
    });
    // const AEID_Q2_AE_Missed=this.state.errors.AEID_Q2_AE_Missed
    let scoreDetails = this.state;
    let siteInfoProducts = siteinfo.Product;
    const {
      caseType,
      channel,
      QMAssociate,
      amgenQCBy,
      subcaseNumber,
      datasetNameView,
      datasetName,
      questionStatus,
      ScorecardName,
    } = scoreDetails;
    let { product } = scoreDetails;
    if (!siteinfo.Product[product]) {
      siteInfoProducts[product] = product;
    } else {
      product = siteinfo.Product[product];
    }
    const productOptions =
      siteInfoProducts &&
      Object.keys(siteInfoProducts)
        .sort()
        .map((product, index) => {
          return (
            <option key={index} value={siteInfoProducts[product]}>
              {product}
            </option>
          );
        });
    // const siteinfo = JSON.parse(utils.getSessionItem("SiteInfo"));
    const role = utils.getSessionItem("role");
    // // console.log(siteinfo.ScorecardLabels);
    // const scoreCardLables = siteinfo.ScorecardLabels;
    const isFormDisabled =
      ((utils.getSessionItem("role") === RoleConstant.SuperAdmin ||
        utils.getSessionItem("role") === RoleConstant.SAdmin) &&
        this.state.createdBy === utils.getSessionItem("userId") &&
        (this.state.stage !== "otherAdmin" ||
          this.props.scoreCard === "new")) ||
      ((utils.getSessionItem("role") === RoleConstant.SuperAdmin ||
        utils.getSessionItem("role") === RoleConstant.SAdmin) &&
        this.state.createdBy === utils.getSessionItem("userId")) ||
      utils.getSessionItem("role") === RoleConstant.Admin;

    const isScorecardNameFieldDisabled =
      ((utils.getSessionItem("role") === RoleConstant.SuperAdmin ||
        utils.getSessionItem("role") === RoleConstant.SAdmin) &&
        this.state.createdBy === utils.getSessionItem("userId") &&
        (this.state.stage !== "otherAdmin" ||
          this.props.scoreCard === "new")) ||
      ((utils.getSessionItem("role") === RoleConstant.SuperAdmin ||
        utils.getSessionItem("role") === RoleConstant.SAdmin) &&
        this.state.createBy === utils.getSessionItem("userId")) ||
      utils.getSessionItem("role") === RoleConstant.Admin ||
      this.state.ScorecardName != "";

    const disabled = !this.state.scorecardId && this.props.scoreCard === "new" ? false : isFormDisabled  
    const isDisabled = !this.state.scorecardId && this.props.scoreCard === "new" ? false : true

    const backButton = (
      <Button
        variant="secondary"
        className="mt-4 clear follow-up-back mr-2"
        onClick={this.goBackTo}
      >
        <img
          src="Images/icon-arrow-left.png"
          className="btn-back"
          alt="Amgen"
        />
        Back
      </Button>
    );

    const completeButton =
      this.state.scorecardId && this.state.questionaries.length &&
        (((utils.getSessionItem("role") === RoleConstant.SuperAdmin ||
          utils.getSessionItem("role") === RoleConstant.SAdmin) &&
          this.state.createdBy === utils.getSessionItem("userId")) ||
          utils.getSessionItem("role") === RoleConstant.Admin) ? (
        <Button
          onClick={this.showAdminDetails}
          className="mt-4 button-color follow-up-back"
        >
          Submit
        </Button>
      ) : (
        ""
      );

    const completeScorecardButton =
      this.state.scorecardId && this.state.questionaries && this.state.questionaries.length ? (
        <Button
          onClick={() => {this.completeScorecard(false)}}
          className="mt-4 button-color follow-up-back"
        >
          Complete
        </Button>
      ) : (
        ""
      );
    // const SaveScorecardButton =
    //   this.state.scorecardId && this.state.questionaries &&
    //     this.state.questionaries.length &&
    //     this.state.createdBy === utils.getSessionItem("userId") ? (
    //     <Button
    //       onClick={() => {
    //         this.saveScorecard(false);
    //       }}
    //       className="mt-4 button-color follow-up-back"
    //     >
    //       Save
    //     </Button>
    //   ) : (
    //     ""
    //   );
    const routetoQM =
      (utils.getSessionItem("role") === RoleConstant.Reviewer ||
        utils.getSessionItem("role") === RoleConstant.SuperAdmin ||
        utils.getSessionItem("role") === RoleConstant.SAdmin) &&
        this.state.createdBy !== utils.getSessionItem("userId") ? (
        <Button
          onClick={() => {this.routetoQM(false)}}
          className="mt-4 button-color mr-2 follow-up-back"
        >
          Route To User
        </Button>
      ) : (
        ""
      );

    const dropdown = (options, selected, question, type, id) => {
      let self = this;
      let dropdwonValues;
      if (type === "SingleSelect") {
        if (options) {
          options = { 0: "--Select--", ...options };
          dropdwonValues = Object.keys(options).map((option) => {
            return option === "0" ? (
              <option hidden value="" key={option}>
                {options[option]}
              </option>
            ) : (
              <option value={options[option]} key={option}>
                {options[option]}
              </option>
            );
          });
        }
        return (
          <Form.Control
            as="select"
            size="sm"
            id={id}
            name={question}
            onChange={(e) => self.handleChangeYesNo(e, question, id)}
            disabled={!isFormDisabled ? true : null}
            className="am-form-placeholder"
            value={selected}
          >
            {dropdwonValues}
          </Form.Control>
        );
      } else if (type === "MultiSelect") {
        let multiselectOptions = [];
        Object.keys(options).map((option) => {
          return multiselectOptions.push({
            id: option,
            label: options[option],
            value: options[option],
          });
        });
        return (
          <div id={id} class="MultiSelectContainer">
            <MultiSelect
              options={multiselectOptions}
              value={multiselectOptions.filter(option =>
                (selected || []).includes(option.value)
              )}
              disableSearch={false}
              disabled={!isFormDisabled}
              hasSelectAll={true}
              filterOptions={this.customFilter}
              onClick={this.handleChangeYesNo}
              onChange={(selectedOptions) => {
                const selectedValues = selectedOptions
                  ? selectedOptions.map(item => item.value)
                  : [];

                const ConainerElem = event.target.closest(
                  ".MultiSelectContainer.invalid"
                );

                if (ConainerElem) {
                  ConainerElem.classList.remove("invalid");
                }
                const question = this.state.questionaries;

                question.forEach((val, i) => {
                  if (val.id === id) {
                    Object.assign(question[i], {
                      answer: selectedValues
                    });
                  }
                });

                this.setState({
                  questionaries: question,
                  formChanged: true,
                  isAutoSave: true
                });
                this.triggerAutoSave();
              }}
              ClearSelectedIcon={null}
              valueRenderer={(selected) => {
                if (!selected.length) {
                  return "--Select--";
                }

                if (selected.length === multiselectOptions.length) {
                  return "All are Selected";
                }

                return selected.map(option => option.label).join(", ");
              }}
              labelledBy="--Select--"
              overrideStrings={{
                selectSomeItems: "--Select--",
                allItemsAreSelected: "All are Selected",
                selectAll: "Select All",
              }}
            />
          </div>
        );
      } else if (type === "Text") {
        return (
          <Form.Control
            type="text"
            id={id}
            name={question}
            onChange={(e) => self.handleChangeYesNo(e, question, id)}
            value={selected}
            disabled={!isFormDisabled}
          />
        );
      } else {
        return (
          <Form.Control
            as="select"
            id={id}
            size="sm"
            name={question}
            onChange={(e) => self.handleChangeYesNo(e, question, id)}
            disabled={!isFormDisabled ? true : null}
            value={selected}
          >
            {/* {dropdwonValues} */}
            <option value="" key="" hidden>
              --Select--
            </option>
            <option value="yes" key="Yes">
              Yes
            </option>
            <option value="no" key="No">
              No
            </option>
            <option value="n/a" key="N/A">
              N/A
            </option>
          </Form.Control>
        );
      }
    };

    const numberField = (score) => {
      const currentValue = this.getCurrentValue(score);
      return (
        <Form.Control
          id={`score-${score.id}`}
          type="number"
          size="sm"
          min={0}
          max={parseInt(score.numericWeightage, 10)}
          value={currentValue}
          disabled={!isFormDisabled ? true : null}
          onChange={(e) => {
            e.target.classList.remove("invalid");
            this.handleScoreChange(e, score)}}
          step={1}
        />
      );
    };


//     let commentHist = Array.isArray(this.state.comment)
//   ? [...this.state.comment]
//   : [];

// if (commentHist.length) {
//   commentHist.sort((a, b) => (b.modifiedAt || 0) - (a.modifiedAt || 0));
// }
const commentHist = Array.isArray(this.state.comment)
  ? this.state.comment
      .filter((comment) => comment.status !== "Saved")
      .sort((a, b) => (b.modifiedAt || 0) - (a.modifiedAt || 0))
  : [];
// const formatCommentDate = (timestamp) => {
//   if (!timestamp) return "-";
//   const value = Number(timestamp);
//   const millis = value < 1e12 ? value * 1000 : value;
//   return new Date(millis).toLocaleDateString();
//   formatCommentDate(data.modifiedAt)
// };

const commentHistoryCards =
  commentHist.length > 0 ? (
    commentHist.slice(0, 3).map((data, index) => (
      <Card className="commentHistory mb-2" key={index}>
        <div className="cmt">
          <span className="updatedBy">Updated By: {data.modifiedBy}</span>
          <span className="updatedAt">
            Updated At:{" "}
            <Moment unix format="MM/D/YYYY">
              {data["modifiedAt"]}
            </Moment>
          </span>
        </div>
        <Card.Body>{data.comments}</Card.Body>
        {/* <div className="comment-body">{data.comments}</div> */}
      </Card>
    ))
  ) : (
    <Card className="mb-2">
      <Card.Body>Comments Not Available</Card.Body>
    </Card>
  );

    let ccAdmin = this.state.interactionOwnerName
      ? this.state.interactionOwnerName
      : this.state.interactionOwner;

    const adminOption = this.state.adminUsers.sort().map((role, i) => {
      return (
        <option
          key={i}
          value={role.id}
        >{`${role.firstName} ${role.lastName} (${role.role})`}</option>
      );
    });

    // console.log("selectedAdmin", this.state.selectedAdmin,'adminOption',this.state.adminUsers);    
    return (
      <div>
        <div style={{
          position: 'fixed',
          top: '20px',
          left: '89%',
          transform: 'translateX(-50%)',
          zIndex: 9999,
          width: '400px',
          textAlign: 'left'
        }} >
          <Messages ref={this.messages} />
        </div>
          <div className="content-layout">
          {this.state.showViewDetails ? (
            <ViewScoreCardDetails
              details={this.state.scorecardDetails}
              hideDetails={this.hideViewDetails}
              scorecard={this.props.scoreCard}              
              passed={this.state.isPassed}
              goBackToHome={this.goBackToHome}
            />
          ) : (
            <div>
              <div className="score-details-layout">
                <div className="score-card">
                  <Form onSubmit={this.handleSearch} className="editScoreForm">
                    <Form.Row>
                      <Col md="4">
                        <Form.Label>Sub-Case Number</Form.Label>
                        <Form.Control
                          type="text"
                          disabled
                          name="subcaseNumber"
                          value={subcaseNumber.toUpperCase()}
                          onChange={this.handleChangeYesNo}
                        />
                        {/* </Form.Group> */}
                      </Col>
                      <Col md="4">
                        <Form.Label>Dataset</Form.Label>
                        <Form.Control
                          type="text"
                          disabled
                          name="datasetName"
                          value={
                            this.props.scoreCard === "new"
                              ? datasetNameView
                              : datasetName
                          }
                          onChange={this.handleChangeYesNo}
                        />
                        {/* </Form.Group> */}
                      </Col>
                      {/* <Col md='3'>
                        <Form.Label>Case Type</Form.Label>
                        <Form.Control as='select' name='caseType' disabled value={caseType} onChange={this.handleChangeYesNo}> */}
                      {/* <option value="">--- ALL ---</option> */}
                      {/* {ifrOptions}
                        </Form.Control>
                      </Col> */}
                      <Col md="4">
                        <Form.Label>Intake Channel Type</Form.Label>
                        <Form.Control
                          as="select"
                          disabled
                          name="channel"
                          value={channel}
                          onChange={this.handleChangeYesNo}
                        >
                          <option value="">--Select--</option>
                          {channelOptions}
                        </Form.Control>
                      </Col>
                    </Form.Row>
                    <Form.Row className="am-questions">
                      <Col md="4">
                        <Form.Label>Products</Form.Label>
                        <Form.Control
                          as="select"
                          id="product"
                          name="product"
                          value={product}
                          onChange={this.handleChangeYesNo}
                          disabled={!isFormDisabled ? true : null}
                        >
                          <option value="">--Select--</option>
                          {productOptions}
                          <option value="N/A">N/A</option>
                        </Form.Control>
                      </Col>
                      <Col md="4">
                        <Form.Label>Call Center Agent</Form.Label>
                        <Form.Control
                          type="text"
                          name="callcenterAdmin"
                          disabled
                          value={ccAdmin}
                        />
                      </Col>
                      <Col md="4">
                        <Form.Label>Created by Team</Form.Label>
                        <Form.Control
                          type="text"
                          name="associatedTeam"
                          disabled
                          value={this.state.associatedTeam}
                        />
                      </Col>
                    </Form.Row>
                    <Form.Row className="am-questions">
                      {
                        <Col md="4">
                          <Form.Label>Question Set</Form.Label>

                          <Form.Control
                            as="select"
                            name="questionsetName"
                            onChange={(e) => {
                              this.questionsetNameChanges(e);
                              const invalidFields = document.querySelectorAll(".invalid");
                              invalidFields.forEach(field => {
                                field.classList.remove("invalid");
                              });
                            }}
                            className="am-form-placeholder"
                            value={
                              !isExistingQuestionset
                                ? ""
                                : this.state.selectedQuestionset
                            }
                            disabled={!isFormDisabled}
                          >
                            <option value="" disabled>
                              {" "}
                              -- Select --
                            </option>
                            {questionsetOptions}
                          </Form.Control>
                        </Col>
                      }
                      <Col md="4">
                        <Form.Label>QM Associate</Form.Label>
                        <Form.Control
                          type="text"
                          name="QMAssociate"
                          value={QMAssociate}
                          onChange={(e) => {
                            this.setState({ QMAssociate: e.target.value });
                          }}
                          disabled
                        />
                      </Col>

                      <Col md="4">
                        <Form.Label>Amgen QC By</Form.Label>
                        <Form.Control
                          type="text"
                          name="amgenQCBy"
                          disabled
                          value={amgenQCBy ? amgenQCBy : "-"}
                          onChange={(e) => {
                            this.setState({ amgenQCBy: e.target.value });
                          }}
                        />
                      </Col>
                    </Form.Row>
                    <Form.Row className="am-questions">
                      <Col md="4">
                        <Form.Label>Scorecard Name</Form.Label>

                        <Form.Control
                          type="text"
                          name="cardName"
                          value={
                            ScorecardName
                              ? ScorecardName
                              : this.state.ScorecardName
                          }
                          onChange={(e) => this.handleInputChange("ScorecardName", e.target.value)}                        
                                                    
                          onCompositionStart={this.onCompositionStart} 
                          onCompositionEnd={this.onCompositionEnd}                            
                          disabled={!disabled}
                        />
                      </Col>
                    </Form.Row>
                  </Form>
                  {/* <Row className='row-end-border'>
                </Row> */}

                  {this.state.scorecardId && this.state.questionaries &&
                    this.state.questionaries.length > 0 ? (
                    <div>
                      <table>
                        <thead>
                          <tr>
                            {/* <th></th> */}
                            <th className="original-qm-width">
                              {this.props.scoreCard === "new"
                                ? this.state.questionsetName
                                : this.props.questionaries.questionsetName}{" "}
                              {!isExistingQuestionset && (
                                <span className="am-required">*</span>
                              )}
                            </th>
                            <th>Options</th>
                            <th>Criticality</th>
                            {(() => {
                              const hasNumericWeightage = this.state.questionaries
                              return hasNumericWeightage?.some((a) => a.hasOwnProperty("numericWeightage")) ? (
                                <th>Weightage</th>
                              ) : null;
                            })()}
                            {(() => {
                              const hasScores = this.state.updatedScore
                              return hasScores?.some((a)=>a.hasOwnProperty("value")) ?  
                               (
                                <th>Score</th>
                              ) : null;
                            })()}

                            {/* <th className='qc-error-width'>Quality Monitor QC</th>
                        <th>Amgen QC</th>
                        <th className='qc-error-width'>Error Reconciliation</th> */}
                          </tr>
                        </thead>

                        <tbody>
                          {(() => {
                            // Step 1: Sort questions by section
                            const sortedQuestions = [
                              ...this.state.questionaries,
                            ].sort((a, b) => {
                              return (
                                a.questionSectionType ?? ""
                              ).localeCompare(b.questionSectionType ?? "");
                            });

                            // Step 2: Group questions by section
                            const groupedQuestions = sortedQuestions.reduce(
                              (acc, question) => {
                                const section =
                                  question.questionSectionType || "";
                                if (!acc[section]) acc[section] = [];
                                acc[section].push(question);
                                return acc;
                              },
                              {}
                            );

                            // Step 3: Render grouped questions
                            return Object.entries(groupedQuestions).map(
                              ([section, questions]) => (
                                <React.Fragment key={section}>
                                  <tr className="section-header-row">
                                    <td colSpan="5" className="section-header">
                                      <strong>{section}</strong>
                                    </td>
                                  </tr>
                                  {questions.map((q, index) => {
                                    const selectedValue = q.answer || "";
                                    return (
                                      <tr key={index}>
                                        <td>{q.question}</td>
                                        <td>
                                          {dropdown(
                                            q.options,
                                            selectedValue,
                                            q.question,
                                            q.type,
                                            q.id
                                          )}
                                        </td>
                                        <td>{q.weightage}</td>

                                        {(() => {
                                          const numericWeightage = this.state.questionaries
                                          return numericWeightage?.some((a) => a.hasOwnProperty("numericWeightage")) ? (
                                            <td>{q.numericWeightage}</td>
                                          ) : null;
                                        })()}
                                        {(() => {
                                          const scores = this.state.updatedScore
                                          return scores?.some((a)=>a.hasOwnProperty("value")) ? (
                                            <td>{numberField(q)}</td>
                                          ) : null;
                                        })()}
                                      </tr>
                                    );
                                  })}
                                </React.Fragment>
                              )
                            );
                          })()}
                        </tbody>
                      </table>
                      {(() => {
                        const questionSet = this.state.questionaries
                        if (!questionSet?.some((a) => a.hasOwnProperty("numericWeightage")))
                          return null;

                        return (
                          <div className="score-card-total-1">

                            <Row>
                              <Col md={9} sm={3} className="pl-3">
                                <label className="mb-2">Scorecard Status</label>
                              </Col>
                              <Col>
                               {this.state.questionStatus ? this.state.questionStatus.charAt(0).toUpperCase() + this.state.questionStatus.slice(1) : ""}                              
                              </Col>
                            </Row>

                            {/* <Row>
                              <Col sm={10}>Question Status</Col>
                              <Col>
                                <b>{this.state.isPassed}</b>
                              </Col>
                            </Row> */}
                            <Row>
                              <Col sm={10}>Final Score</Col>
                              {/* <Col>{totalScore} %</Col> */}
                              <Col>{this.state.finalScore}</Col>
                            </Row>
                          </div>
                        );
                      })()}
                    </div>
                  ) : (
                    ""
                  )}
                </div>

                <div className="layout-2">
                  <Row>
                    <Col md={12} sm={12}>
                      <label className="mb-2">Comments</label>

                      {/* {this.props.scoreCard==='new'? */}
                      <Form.Control
                        as="textarea"
                        name="newcomment"
                        // value={ commentHist[commentHist.length-1]?.comments ? commentHist[commentHist.length-1]?.comments : this.state.newcomment}
                        // value={
                        //   this.state.newcomment
                        //     ? this.state.newcomment
                        //     : Array.isArray(commentHist) &&
                        //       commentHist.length > 0 &&
                        //       commentHist[commentHist.length - 1]
                        //         ?.modifiedBy ===
                        //       utils.getSessionItem("firstName") +
                        //       " " +
                        //       utils.getSessionItem("lastName") &&
                        //       commentHist[commentHist.length - 1].status ===
                        //       "Saved"
                        //       ? commentHist[commentHist.length - 1]?.comments ||
                        //       ""
                        //       : ""
                        // }
                        value={this.state.newcomment}
                        onChange={this.handleCommentsChange}
                        disabled = {!isDisabled}
                      />
                    </Col>
                  </Row>

                  {/* <Row className="mt-3">
                    {commentHistoryCards}
                    <Col md={12} sm={12}>
                      {commentHist.length >= 3 && (
                        <span onClick={this.showHistory} className="showCmts">
                          Show Comment History
                        </span>
                      )}
                    </Col>
                  </Row> */}
                  <Row>
                    <Col md={12} sm={12}>
                      <label className="mb-2">
                            Comment History
                            {/* {(utils.getSessionItem("role") === RoleConstant.SuperAdmin && scoreDetails.stage === RoleConstant.SuperAdmin) ?
                          <img className="edit-case-owner" onClick={this.editComment} src="/Images/ico-edit.png" alt='Amgen' /> : ''} */}
                          </label>
                     {commentHistoryCards}
                     {Array.isArray(commentHist) &&
                        commentHist.length >= 3 && (
                          <span
                            onClick={this.showHistory}
                            className="showCmts"
                         >
                        Show Comment History
                          </span>
                       )}
                     </Col>
                     </Row>
                </div>
              </div>
              {/* <div className="row"><div className="col-xs-12 col-md-12"> 
      <button className="col-md-1 offset-11 btn-gobackTo mt-4 mb-4 pull-right" onClick={this.goBackTo}>Back</button></div>
    </div> */}
              <div className="row pull-right">
                <div className="col-xs-12 col-md-12">
                  {/* <Button type="submit" onClick={this.showFollowUp} className='mt-4 button-color follow-up-back'>Follow Up</Button> */}
                  {backButton}{" "}                 
                  {completeScorecardButton} {routetoQM}
                  {completeButton}
                </div>
              </div>
            </div>
          )}
          <PopupModels
            showPopup={this.state.scorecardUpdateModel}
            iconFlag="success"
            message={
              this.state.isDraft
                ? MessageConstant.SAVE_SCORECARD
                : this.props.scoreCard === "new"
                  ? MessageConstant.ADD_SCORECARD
                  : this.state.isComplete
                    ? MessageConstant.COMPLETED_SCORECARD
                    : MessageConstant.UPDATE_SCORECARD
            }
            handleClosePopup={this.handleUpdateClose.bind(this, false)}
          />
          <PopupModels
            showPopup={this.state.scorecardErrorModel}
            iconFlag="error"
            message={MessageConstant.SCORECARD_ERROR}
            handleClosePopup={this.handleErrorClose.bind(this)}
          />
          <PopupModels
            showPopup={this.state.scorecardNoUserError}
            iconFlag="error"
            message={MessageConstant.SCORECARD_NO_USER_ERROR}
            handleClosePopup={this.handleNoUserErrorClose.bind(this)}
          />
          <PopupModels
            showPopup={this.state.duplicateScorecard}
            iconFlag="error"
            message={MessageConstant.DULICATE_SCORECARD}
            handleClosePopup={this.handleDuplicateSCNameError.bind(this)}
          />
          <Modal
            size="lg"
            show={this.state.showComment}
            onHide={this.hideHistory}
            aria-labelledby="example-modal-sizes-title-sm"
          >
            <Modal.Header closeButton>
              <Modal.Title id="example-modal-sizes-title-sm">
                Comment History
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="scrollcommentpopup">
              <CommentHistory commentHist={commentHist} />
            </Modal.Body>
          </Modal>
          <Modal
            show={this.state.showAdminPopup}
            onHide={this.handleAdminPopupClose}
          >
            <Modal.Header closeButton className="add-user-header">
              Assign To
            </Modal.Header>
            <Form.Row className="reg-form">
              <Form.Group
                as={Col}
                controlId="adminName"
                className="mt-4 pl-4 pr-4"
              >
                <Form.Label className="align-lable">
                  Select users to assign scorecard
                </Form.Label>
                <Form.Control
                  as="select"
                  name="assign"
                  value={this.state.selectedAdmin}
                  onChange={(e) => {
                    this.setState({ selectedAdmin: e.target.value });
                  }}
                >
                  <option value="">--Select--</option>
                  {adminOption}
                  <option value="Admin">Admin</option>
                  {/*  <option value='Reviewer'>Reviewer</option>   */}
                  <option value="SuperAdmin">SuperAdmin</option>
                </Form.Control>
              </Form.Group>
            </Form.Row>
            <Form.Group as={Col} controlId="adminName" className="pl-4 pr-4">
              <Button
                variant="secondary"
                type="button"
                className="button-color mb-4 float-right"
                onClick={() => {this.submitScorecard(false)}}
                disabled={this.state.selectedAdmin.length === 0}
              >
                {" "}
                Submit{" "}
              </Button>
            </Form.Group>
          </Modal>
          <PopupModels
            showPopup={this.state.extractValidation}
            iconFlag="error"
            message={this.state.extractErrMsg}
            handleClosePopup={this.handleExtractValidationClose.bind(this)}
          />
          <Modal show={this.state.showAlertModal} onHide={this.hideAlertModal}>
            <Modal.Header closeButton>
              <Modal.Title id="example-modal-sizes-title-sm">
                Alert
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="scrollcommentpopup">
              {this.state.modalMessage}
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="button-color float-right"
                onClick={this.hideAlertModal}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>

        </div>
      </div>
    );
  }
}
EditScoreCard.propTypes = {
  details: PropTypes.object,
  scoreCard: PropTypes.string,
  hideDetails: PropTypes.func,
  hideEditScoreCard: PropTypes.func,
  questionaries: PropTypes.array,
  goBackToHome: PropTypes.func,
};

export default EditScoreCard;
